/* global GOOGLE_TAG_ID */
import TagManager from 'react-gtm-module';
import { useEffect } from 'react';

const startTagManager = (() => {
  const startedTags = [];
  return id => {
    if (startedTags.includes(id)) {
      return;
    }
    TagManager.initialize({ gtmId: id });
    startedTags.push(id);
  };
})();

const GoogleTagManager = () => {
  useEffect(() => {
    if (!GOOGLE_TAG_ID) {
      return;
    }
    startTagManager(GOOGLE_TAG_ID);
  }, []);
  return null;
};

export default GoogleTagManager;
